module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAAAoCAYAAAAFZi8EAAAABHNCSVQICAgIfAhkiAAAARxJREFUaIHtm1Fqg0AUAGdLryDNcczJ0tzM3ibBQ9ifWMS61o/mvYXM/MkiLAzjw0XL+MGE/DcDha/uxufRG4oinkzhekTIW8BWXpuJy3j6W4RFRFE4dzeG2rJFRDFx2VtWRBz9eKKvLSoikp0qFBFLtQpFRFOpQhHxbFahiAw2qlBEDr+qUEQWqyoUkUe/vFBEIsszKM+akunuFLCIdOahrYhsHkNbEY3gjGiBwlkRDdDdKT6aGkER2RSuoIhmcEYk4wtdCzweS2ARqcw1gEXksagBLCKNZQ1gETmsagBFNIMioql8Ha6IRnBYB7Me0jMWEcnGkP5Zsog4ajWARcSxUwMoIoYD/9Ep4tkc/JnxPWArr8YAzAKGozd9A+Y5RZqk+SGuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/student/week.png
// module id = IHaH
// module chunks = 1